<div
  class="searchbar position-relative"
  (click)="focus()"
  [ngClass]="{ mobile: mobile }">
  <input
    #searchbox
    type="text"
    [(ngModel)]="query"
    (keypress)="checkSubmit($event)"
    (focus)="suggest()"
    (blur)="unfocus()"
    (input)="suggest()"
    placeholder="Search..." />
  <button
    *ngIf="query"
    class="btn fa fa-times position-absolute top-50 end-0 translate-middle-y z-2 text-body-secondary"
    title="Clear"
    (click)="clear()"></button>
  <i
    (click)="search($event)"
    *ngIf="mobile"
    class="icon-searchglass"
    [ngClass]="{ active: focused && query }"></i>

  <div class="suggestions" [ngClass]="{ active: focused && query }">
    <div class="list">
      <div class="suggestion" (click)="search($event)">
        <div class="text">
          <span class="default">search for</span>
          {{ query }}
        </div>
      </div>
      <div
        (click)="suggestion.open($event)"
        class="suggestion"
        *ngFor="let suggestion of suggestions">
        <div class="text">
          <ng-container *ngFor="let segment of suggestion.segments">
            <ng-container *ngIf="!segment.m">{{ segment.t }}</ng-container>
            <b *ngIf="segment.m">{{ segment.t }}</b>
          </ng-container>
        </div>
        <div class="type">{{ suggestion.type }}</div>
      </div>
    </div>
  </div>
</div>
